import request from './index'

// 新增租户 + 账号快捷配置约定；身份范围由后端从登录上下文确定。
export function getShortcutConfig() {
  return request({ url: '/platform/shortcutMenu/config', method: 'get' })
}
export function saveShortcutConfig(data) {
  return request({ url: '/platform/shortcutMenu/save', method: 'post', data })
}
export function resetShortcutConfig(data) {
  return request({ url: '/platform/shortcutMenu/reset', method: 'post', data })
}
